import React from "react";

import { Button } from "../../Button";
import { Text } from "../../Text";
import { TextTypes, TextColors, ButtonTypes } from "../../constants";

import "./styles.scss";

// Relates to: Self Signup

export const VerifyInsuranceNotConfigured = ({ insuranceName, onClick, step, title }) => {
  return (
    <div className="apti-VerifyInsurance">
      <Text color={TextColors.green} type={TextTypes.heading1}>
        {title}
      </Text>
      <Text className="details" style={{ color: TextColors.grey }}>
        Please contact <span className="bold">{insuranceName}</span> before your first appointment
        to confirm your coverage and cost of care.
      </Text>
      <Button className={ButtonTypes.primary} onClick={onClick}>
        Continue
      </Button>
      {/* <Text className="details" style={{color: TextColors.grey}}>
            If aptihealth’s services are not covered, you will be responsible for any fees associated with your care. <Link href={`/session-pricing`}>Learn about aptihealth’s rates.</Link>
            </Text> */}
    </div>
  );
};

VerifyInsuranceNotConfigured.defaultProps = {
  insuranceName: "HDEPO National HRA",
  onClick: () => {},
  title: "Great news – you’re covered!",
};
